export default "__VITE_ASSET__CJL$rEKC__"